module.exports = __webpack_public_path__ + "static/media/Tyler Stevenett Headshot.8860ddb2.jpeg";